import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'areaservicio/pdf';
const CONTEXT_BASE_HTML_PATH = 'areaservicio/html';
const CONTEXT_SINGLE_BASE_PATH = 'areaservicio/pdfindividual';
// #endregion

// #region Public functions
async function getServiceAreaPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchServiceAreaPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchServiceAreaHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getServiceAreaPdf,
  searchServiceAreaPdf,
  searchServiceAreaHtml,
};
